"use client";

import { type FC, useEffect, useState } from "react";
import { type ClassNameProp, Stack } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import { containerStyle, graphicStyle } from "./HouseGraphicsBackground.css";
import {
  graphicAnimations,
  floatingAnimations,
} from "./HouseGraphicsBackground.motion";
import { HouseGraphic } from "../HouseGraphic";

export type HouseGraphicsBackgroundProps = ClassNameProp & {
  variant?: "default" | "banner";
};

const housePositions = ["a", "b", "c", "d"] as const;

export const HouseGraphicsBackground: FC<HouseGraphicsBackgroundProps> = ({
  className,
  variant = "default",
}) => {
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFloating(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Stack className={mergeClasses(containerStyle({ variant }), className)}>
      {housePositions.map((position) => (
        <HouseGraphic
          key={position}
          className={mergeClasses(graphicStyle({ position }))}
          {...graphicAnimations[position]}
          animate={
            showFloating
              ? floatingAnimations[position]
              : graphicAnimations[position].animate
          }
        />
      ))}
    </Stack>
  );
};
